import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UIState } from './ui.state';
import { uiFeatureKey } from './ui.reducer';

// Selector for the 'ui' feature state
export const selectUiState = createFeatureSelector<UIState>(uiFeatureKey);

// Selectors for specific parts of the UIState
export const selectIsSidebarOpen = createSelector(
  selectUiState,
  (state: UIState) => state.isSidebarOpen
);

export const selectSidebarItems = createSelector(
  selectUiState,
  (state: UIState) => state.sidebarItems
);

export const selectIsLoading = createSelector(selectUiState, (state: UIState) => state.isLoading);
